import {numbers, dateformats} from 'motivate-vue-util/dist/lib/filters';
import Vue from "vue";
import _ from 'lodash'
_.forEach(numbers, (filter, key) => {
    Vue.filter(key, filter)
})
_.forEach(dateformats, (filter, key) => {
    Vue.filter(key, filter)
})

